"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EhrLoginLogout = void 0;
var EhrLoginLogout_1 = require("./EhrLoginLogout");
Object.defineProperty(exports, "EhrLoginLogout", { enumerable: true, get: function () { return EhrLoginLogout_1.EhrLoginLogout; } });
//# sourceMappingURL=index.js.map